export const DEFAULT_CAROUSEL_ITEM_DURATION_S = 15;
